<template>
  <div class="d-flex justify-center">
    <div
      style="width: 90%;">
      <v-simple-table
        fixed-header
        height="240px"
        id="style-2"
        class=""
      >
        <template v-slot:default>
          <thead>
          <tr>
            <th
              colspan="2"
              class="white--text"
              style="background: #1289f8; min-width: 250px; max-width: 250px; position: sticky; left: 0px; z-index: 4"
            >
              <div class="d-flex justify-center">
                <transition-group tag="div" class="div-slider w-100" :name="!isViewDetailSubject? 'slideback' : 'slide'">
                  <div v-if="isViewDetailSubject" :key="'duo-header'" class="w-100 text-left card">
                    <v-icon color="white" class="mr-2" style="cursor: pointer" @click="handleViewDetailSubject()">mdi-arrow-left</v-icon>
                    Khung chương trình
                  </div>
                  <div v-else :key="'duo-header-detail'" class="w-100 text-left card">
                    Môn - Khối lớp
                  </div>
                </transition-group>
              </div>
            </th>
            <th
              v-for="(column, index) in dataColumn"
              class="white--text"
              style="background: #1289f8; min-width: 100px; max-width: 100px"
              :key="'th' + index"
            >
              {{ column }}
            </th>
          </tr>
          </thead>
          <tbody v-if="dataTable && dataTable.length">
            <template v-for="(data, index) in computedDataTable">
              <tr :key="index + 'rowData'">
                <td rowspan="2" style="border-right: 2px solid white; min-width: 150px; max-width: 150px; position: sticky; left: 0">
                  <div :class="!isViewDetailSubject ? 'hover-to-underline' : ''" @click="!isViewDetailSubject ? handleViewDetailSubject(index) : ''">
                    <strong>{{ !isViewDetailSubject ? data.subjectGradeName : data.programName}}</strong>
                  </div>
                </td>
                <td style="position: sticky;left: 152px">
                  <strong>BTVN</strong>
                </td>
                <td>
                  <div v-if="data.homeworks">
                    {{data.homeworks.totalHomeworkCompleted}}/{{data.homeworks.totalHomework}} bài
                  </div>
                </td>
                <td>
                  <div v-if="data.homeworks">
                    {{data.homeworks.totalQuestion}}
                  </div>
                </td>
                <td>
                  <div v-if="data.homeworks">
                    {{data.homeworks.totalCorrectQuestion}}
                  </div>
                </td>
                <td>
                  <div v-if="data.homeworks">
                    {{data.homeworks.totalWrongQuestion}}
                  </div>
                </td>
                <td style="border-right: 2px solid white;">
                  <div v-if="data.homeworks" class="d-flex align-center justify-center">
                    {{data.homeworks.avgPoint}}
                    <div class="d-flex align-center justify-center">
                      <div v-if="data.homeworks.compare" class="ml-2 pb-2">
                        <v-icon v-if="data.homeworks.compare === 'increase'" color="#00b23b" style="font-size: 14px">mdi-arrow-up</v-icon>
                        <v-icon v-else-if="data.homeworks.compare === 'decrease'" color="red">mdi-arrow-down</v-icon>
                      </div>
                      <div v-if="data.homeworks.comparePoint" class="pb-2" style="font-size: 10px">{{data.homeworks.comparePoint}}</div>
                    </div>
                  </div>
                </td>
                <td rowspan="2">
                  <div v-if="data.homeworks">
                    {{data.homeworks.totalJoinLesson}}/{{data.homeworks.totalLesson}} buổi học
                    <br>
                    <span style="font-size: 12px">{{parseFloat((data.homeworks.totalJoinLesson/data.homeworks.totalLesson) * 100).toFixed(0)}} %</span>
                  </div>
                </td>
              </tr>
              <tr :key="index + 'rowData2'">
                <td style="position: sticky;left: 152px">
                  <strong>Tương tác</strong>
                </td>
                <td colspan="5" style="border-right: 2px solid white;">
                  <div class="d-flex align-center justify-center" v-if="data.interaction && data.interaction.noOfCup !== null">
                    {{data.interaction.noOfCup}} cup
                    <img
                      src="../../assets/cup-icon.svg"
                      height="18"
                      width="18"
                      alt=""
                      class="ml-2"
                    />
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="8">
              <div class="d-flex flex-column">
                <div class="d-flex align-center justify-center mt-3">
                  <img src="../../assets/emty-data-homework.svg" style="width: 380px" alt="">
                </div>
                <span style="font-size: 16px; font-weight: bold; margin-top: 10px">Thời gian lựa chọn không có thông tin điểm học sinh</span>
                <span style="font-size: 12px; margin-top: 6px; margin-bottom: 10px">Bạn chọn khoảng thời gian khác để xem thông tin điểm học tập</span>
              </div>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DuoViewDetailBySubject',
  props: ['dataTable', 'filterForm', 'filter'],
  data() {
    return {
      activeIndex: null,
      isViewDetailSubject: false,
      dataColumn: ['Bài hoàn thành', 'Tổng số câu', 'Số câu đúng', 'Số câu sai', 'Điểm trung bình', 'Tỷ lệ tham gia lớp học'],
      dataInteraction: [],
    };
  },
  methods: {
    handleViewDetailSubject(index = null) {
      this.activeIndex = index;
      this.isViewDetailSubject = !this.isViewDetailSubject;
    },
    onViewInteraction(subject) {
      Bus.$emit('show-modal-interaction', true, subject.subjectId);
    },
  },
  computed: {
    computedDataTable() {
      if (this.isViewDetailSubject) {
        return this.dataTable[this.activeIndex].byProgram;
      } return this.dataTable;
    },
  },
};
</script>

<style lang="scss" scoped>
.div-slider{
  overflow: hidden;
  position: relative;
  height: 20px;
}
.div-slider .card{
  height: 20px;
  position: absolute;
}
.hover-to-underline {
  color: #1289F8;
  cursor: pointer;
}
.hover-to-underline:hover {
  text-decoration: underline;
}
thead tr th,
tbody tr td {
  /*  border: 1px solid #0180c7; */
  text-align: center !important;
  font-size: 14px !important;
}
tbody {
  &:hover {
    td {
      background-color: #f5f5f5;
    }
  }
  td {
    background-color: #f9f4f4;
    border-bottom: solid 2px white !important;
  }
}
.bg-blue {
  background: #52acff;
}
.lesson-radio {
  display: flex;
  width: 60%;
  margin: 0 auto;
}
.compare-tooltip {
  color: black;
  border: 1px solid #d2d2d2;
  padding: 3px 6px;
  border-radius: 8px;
  background-color: white;
}
</style>
